export const PREVIEW_PLATFORM_STORAGE_KEY = 'advertisement-preview-platform';
